module.exports = __webpack_public_path__ + "img/PEP.b68ab275.png";